import { styled, css } from 'styled-components';
import { BREAKPOINTS } from '../../constants/layout.mjs';
import { theme } from '../../constants/theme.mjs';
import '../Button/index.mjs';
import { FormStatus } from './Footer.types.mjs';
import { Button } from '../Button/Button.mjs';
"use strict";
const AnchorGroup = styled.div`
  line-height: 20px;
  display: flex;
  flex-wrap: nowrap;
`;
const Anchor = styled.a`
  text-decoration: none;
  font-size: 12px;
  color: rgb(0 0 0 / 0.65);
  line-height: 20px;
  cursor: pointer;

  &:hover {
    color: #006fff;
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
const CookieBtn = styled.button`
  padding: 0 !important;
  background: none !important;
  border: none !important;
  font-size: 12px !important;
  color: rgb(0 0 0 / 0.65) !important;
  line-height: 20px !important;
  font-family: ${theme.fontFamily.default} !important;

  &:hover {
    color: ${theme.colors.primaryBlue} !important;
  }
`;
const AnchorDivider = styled.span`
  margin: 0 8px;
  color: rgb(0 0 0 / 0.2);
`;
const Break = styled.div`
  border-top: ${({
  $motif
}) => `1px solid ${$motif === "dark" ? "#cecece33" : "#dbdce1"}`};

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: none;
  }
`;
const Copyright = styled.span`
  font-size: 12px;
  color: rgb(0 0 0 / 0.45);
  line-height: 20px;
`;
const Form = styled.form`
  width: 100%;
  max-width: 340px;
`;
const Header = styled.h1`
  color: rgb(0 0 0 / 0.65);
  font-size: 14px;
  line-height: 24px;
  font-weight: bold;
  margin: 0;
`;
const IconsWrapper = styled.div`
  display: flex;
  column-gap: 24px;
  margin-top: 30px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    margin-left: 32px;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    margin-left: unset;
  }
`;
const IconWrapper = styled.a`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  img {
    display: block;
    opacity: 1;
  }

  &:hover {
    cursor: pointer;
    > img {
      opacity: 0.8;
    }
  }
`;
const InnerWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    width: unset;
  }

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    flex-direction: row;
    align-items: center;
    margin-top: 32px;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    flex-direction: column;
    margin-top: unset;
    align-items: center;
  }
`;
const Input = styled.input`
  border: 1px solid #dbdce1;
  margin: 0;
  width: 100%;
  padding: 9px 8px;
  font-weight: 400;
  border-radius: 4px;
  margin-right: 8px;
  line-height: 19px;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #dbdce1;
  }

  &::placeholder {
    font-size: 14px;
    line-height: 24px;
    color: rgb(0 0 0 / 0.45);
    font-family: ${theme.fontFamily.default};
  }

  ${({
  $error
}) => $error && css`
      border-color: ${theme.colors.pomegranate};
    `}
`;
const InputWrap = styled.div`
  display: flex;
  width: 100%;
  margin-top: 4px;
`;
const List = styled.ul`
  list-style: none outside;
  padding-left: 0;
  margin: 8px 0 0;
`;
const ListItem = styled.li`
  margin-top: 4px;
  line-height: 24px;
  font-size: 14px;
`;
const ListItemAnchor = styled.a`
  color: rgb(0 0 0 / 0.45);
  font-weight: normal;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: #006fff;
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
const ListItemWrap = styled.div`
  margin-right: auto;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: none;
  }
`;
const ListsWrap = styled.div`
  display: flex;
  flex-grow: 1;
`;
const FlexWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    justify-content: center;
  }
`;
const FlexWrapResponsive = styled(FlexWrap)`
  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    gap: 16px;
    flex-direction: column;
    justify-content: center;
  }
`;
const TermsWrap = styled(FlexWrapResponsive)`
  justify-content: space-between;
  gap: 16px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    gap: 24px;
  }
`;
const Wrap = styled.div`
  display: flex;
  margin: 16px 0;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    flex-direction: column;
  }
`;
const ContainerWrap = styled.footer`
  background: #f6f6f8;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;

  padding: 16px 0;

  /* dark styling */
  ${({
  $motif
}) => $motif === "dark" && css`
      background-color: #070b0f;

      h1,
      a,
      span {
        color: #525461;
      }
      button#ot-sdk-btn {
        color: #525461 !important;
      }

      button.dark {
        transition: all 0.2s;
        background: #525461;
        border-color: #525461;
        color: white;

        &:hover {
          background: #006fff;
          border-color: #006fff;
        }
      }

      input {
        border: 1px solid #909090;
        background: transparent;
        color: #525461;

        &::placeholder {
          color: #525461;
        }
      }
    `}
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const SubmitButton = styled(Button)`
  text-wrap: nowrap;
`;
const FormMessage = styled.p`
  font-size: 12px;
  color: ${({
  $status
}) => $status === FormStatus.Error ? theme.colors.pomegranate : theme.colors.black45};
  line-height: 20px;
  margin: 8px 0 0 9px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    text-align: center;
  }
`;
const StoreAddress = styled.div`
  font-size: ${theme.font.size12};
  color: ${theme.colors.black65};
  line-height: 20px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    text-align: center;
  }
`;
const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    gap: 32px;
  }
`;
export { Anchor, AnchorDivider, AnchorGroup, Break, Container, ContainerWrap, CookieBtn, Copyright, FlexWrap, FlexWrapResponsive, Form, FormMessage, Header, IconWrapper, IconsWrapper, InnerContainer, InnerWrap, Input, InputWrap, List, ListItem, ListItemAnchor, ListItemWrap, ListsWrap, StoreAddress, SubmitButton, TermsWrap, Wrap };
//# sourceMappingURL=Footer.styles.mjs.map
